/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./vendor/jquery-1.12.4.min');
require('./jquery.sticky');
require('./jquery.ticker');
require('./jquery.ajaxchimp.min');
require('./jquery.magnific-popup');
require('./jquery.form');
require('./jquery.nice-select.min');
require('./jquery.paroller.min');
require('./jquery.scrollUp.min');
require('./vendor/modernizr-3.5.0.min');
require('./slick.min');
require('./jquery.slicknav.min');
require('./wow.min');
require('./main');

require('./popper.min');



require('./jquery.validate.min');
require('./animated.headline');
require('./bootstrap.min');

require('./gijgo.min');


require('./one-page-nav-min');
require('./owl.carousel.min');
require('./plugins');

require('./site');






//Arquivo para jquerys de funcionalidades do site
require('./scripts');
//Modulos externos
//tiny slider
require('./tiny-slider');
//lightgalery
require('./lightgalery');
//Mask
require('./mask');
//select2
require('./select2');
//mapa
require('./mapa');

require('./contact');

// window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


// const app = new Vue({
//     el: '#app',
// });
